<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  selectedTab:
    | 'general'
    | 'investor_settings'
    | 'company_settings'
    | 'automated_reminders'
    | 'email_notifications'
    | 'delete_account'
}>()

const tabs = computed(() => [
  {
    name: 'General',
    to: { name: 'workspace.settings' },
    isActive: props.selectedTab === 'general',
  },
  {
    name: 'Investor Settings',
    to: { name: 'workspace.settings.investor' },
    isActive: props.selectedTab === 'investor_settings',
  },
  {
    name: 'Company Settings',
    to: { name: 'workspace.settings.company' },
    isActive: props.selectedTab === 'company_settings',
  },
  {
    name: 'Automated Reminders',
    to: { name: 'workspace.settings.reminders' },
    isActive: props.selectedTab === 'automated_reminders',
  },
  {
    name: 'Email Notifications',
    to: { name: 'workspace.settings.emails' },
    isActive: props.selectedTab === 'email_notifications',
  },
  {
    name: 'Delete Account',
    to: { name: 'workspace.settings.delete' },
    isActive: props.selectedTab === 'delete_account',
    isDelete: true,
  },
])
</script>

<template>
  <div>
    <div class="sm:flex sm:items-start sm:space-x-8 sm:px-0">
      <div class="space-y-2 sm:w-1/4">
        <RouterLink :key="tab.name" :to="tab.to" v-for="tab in tabs">
          <div
            class="rounded-lg p-4 text-sm"
            :class="{
              'bg-[#3D8A9D]/20 font-semibold text-[#3D8A9D]': tab.isActive && !tab.isDelete,
              'bg-red-50 font-semibold text-red-600': tab.isActive && tab.isDelete,
              'text-red-600': !tab.isActive && tab.isDelete,
            }"
          >
            {{ tab.name }}
          </div>
        </RouterLink>
      </div>
      <div class="sm:w-3/4 sm:px-6">
        <div class="max-w-3xl">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
